import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../common/page-title';
import InlineCKEditor from '../common/editor/inline-editor';
import MyStoreDetails from './store-details';
import {loadPageContent} from '../../actions/content';

class StoreDetails extends Component {
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'store-details';
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    return (
      <Container fluid className="details user-inner-container">
        <Row>
          <Col lg={12} className="details-title">
            <PageTitle>
              Store Details
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              contents={this.props.contents[`${this.pageSlug}_content_text`]}
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
            />
          </Col>
        </Row>
        <Row className="details-store">
          <Col lg={12}>
            <MyStoreDetails storeId={this.props.match.params.id}/>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  contents: state.content.list
});

export default connect(mapStateToProps)(StoreDetails);
